// removed by extract-text-webpack-plugin
module.exports = {"event-group":"event-group","event-count":"event-count","event-name":"event-name","event-value":"event-value"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/event-group/event-group.style.sass
// module id = bugh
// module chunks = 0